import { getTier } from '../utils/helpers'

const SEGMENTS = [1, 2, 3, 4, 5]

function StrengthMeter({ strength, score, compact = false }) {
  const tier = getTier(strength)

  return (
    <div>
      <div className="flex gap-1" role="meter" aria-valuenow={score} aria-valuemin={0} aria-valuemax={100} aria-label={`Password strength: ${tier.label}`}>
        {SEGMENTS.map(n => (
          <span
            key={n}
            className={`h-[5px] flex-1 rounded-full transition-colors duration-200 ${
              n <= tier.rank ? tier.bar : 'bg-surface-muted'
            }`}
          />
        ))}
      </div>
      {!compact && (
        <div className="flex items-baseline justify-between mt-2">
          <span className={`text-[13px] font-medium ${tier.text}`}>{tier.label}</span>
          <span className="font-mono text-xs text-ink-muted">{score}/100</span>
        </div>
      )}
    </div>
  )
}

export default StrengthMeter
